document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {

  const header = document.querySelector('[data-site-header]');
  const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 24);
  updateHeader(); window.addEventListener('scroll', updateHeader, { passive: true });

  const revealObserver = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); } }), { threshold: .12 });
  document.querySelectorAll('.section-head,.product-card,.image-card,.split__content,.finish-swatch,.proof').forEach((element) => { element.classList.add('reveal'); revealObserver.observe(element); });

  const sticky = document.querySelector('[data-sticky-atc]');
  const productSubmit = document.querySelector('[data-product-form] [type="submit"]');
  if (sticky && productSubmit) {
    const stickyObserver = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
    stickyObserver.observe(productSubmit);
    sticky.querySelector('[data-sticky-submit]')?.addEventListener('click', () => productSubmit.click());
  }
  const drawer = document.querySelector('[data-mobile-drawer]');
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!drawer) return;
      const open = !drawer.classList.contains('is-open');
      drawer.classList.toggle('is-open', open);
      document.body.classList.toggle('menu-open', open);
      document.querySelectorAll('[data-menu-toggle]').forEach((toggle) => toggle.setAttribute('aria-expanded', String(open)));
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('select[name="id"]');
    const variantsNode = form.querySelector('[data-variants]');
    if (!select || !variantsNode) return;
    const variants = JSON.parse(variantsNode.textContent);
    const productPanel = form.closest('.product-panel');
    const price = productPanel?.querySelector('[data-product-price]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const submit = form.querySelector('[type="submit"]');
    const stickySubmit = document.querySelector('[data-sticky-submit]');
    const availability = productPanel?.querySelector('[data-availability]');
    const stickyStatus = document.querySelector('[data-sticky-status]');
    const sku = productPanel?.querySelector('[data-product-sku]');
    const skuRow = productPanel?.querySelector('[data-sku-row]');
    const addPrice = form.querySelector('[data-add-price]');
    const stickyOptions = document.querySelector('[data-sticky-options]');
    const optionSelections = [...form.querySelectorAll('[data-option-selection]')];
    const gallery = document.querySelector('[data-product-gallery]');

    const updateVariant = () => {
      const values = [...form.querySelectorAll('[data-option-input]:checked')].map((item) => item.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === values[index]));
      if (!variant) return;
      select.value = variant.id;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      if (price) price.textContent = variant.price_formatted;
      const comparePrice = productPanel?.querySelector('[data-compare-price]');
      const saleBadge = productPanel?.querySelector('[data-sale-badge]');
      const saleSaving = productPanel?.querySelector('[data-sale-saving]');
      const onSale = Number(variant.compare_at_price) > Number(variant.price);
      if (comparePrice) { comparePrice.textContent = onSale ? variant.compare_at_formatted : ''; comparePrice.classList.toggle('is-hidden', !onSale); }
      if (saleBadge) { saleBadge.textContent = onSale ? `Save ${variant.saving_percent}%` : ''; saleBadge.classList.toggle('is-hidden', !onSale); }
      if (saleSaving) { saleSaving.textContent = onSale ? `You save ${variant.saving_formatted}` : ''; saleSaving.classList.toggle('is-hidden', !onSale); }
      if (stickyPrice) stickyPrice.textContent = variant.price_formatted;
      if (addPrice) addPrice.textContent = variant.price_formatted;
      if (stickyOptions) stickyOptions.textContent = variant.title;
      optionSelections.forEach((selection, index) => { selection.textContent = values[index] || ''; });
      if (variant.featured_media_id && gallery) gallery.dispatchEvent(new CustomEvent('gallery:show-media', { detail: variant.featured_media_id }));
      if (availability) availability.textContent = variant.available ? 'Available to order' : 'Unavailable';
      if (stickyStatus) stickyStatus.textContent = variant.available ? 'Available to order' : 'Unavailable';
      if (sku) sku.textContent = variant.sku || '';
      if (skuRow) skuRow.classList.toggle('is-hidden', !variant.sku);
      if (submit) {
        submit.disabled = !variant.available;
        const label = submit.querySelector('[data-add-label]');
        if (label) label.textContent = variant.available ? 'Add to cart' : 'Unavailable';
      }
      if (stickySubmit) {
        stickySubmit.disabled = !variant.available;
        stickySubmit.textContent = variant.available ? 'Add to cart' : 'Unavailable';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    form.querySelectorAll('[data-option-input]').forEach((input) => {
      input.addEventListener('change', updateVariant);
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const activeImage = gallery.querySelector('[data-gallery-active]');
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const counter = gallery.querySelector('[data-gallery-counter]');
    const lightbox = document.querySelector('[data-product-lightbox]');
    const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');
    const lightboxCounter = lightbox?.querySelector('[data-lightbox-counter]');
    let currentIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

    const showImage = (index, openLightbox = false) => {
      if (!activeImage || !thumbs.length) return;
      currentIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[currentIndex];
      activeImage.classList.add('is-changing');
      activeImage.src = thumb.dataset.gallerySrc;
      activeImage.alt = thumb.dataset.galleryAlt || '';
      thumbs.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === currentIndex);
        item.setAttribute('aria-current', itemIndex === currentIndex ? 'true' : 'false');
      });
      if (counter) counter.textContent = `${currentIndex + 1} / ${thumbs.length}`;
      window.setTimeout(() => activeImage.classList.remove('is-changing'), 180);
      if (openLightbox && lightbox && lightboxImage) {
        lightboxImage.src = thumb.dataset.gallerySrc;
        lightboxImage.alt = thumb.dataset.galleryAlt || '';
        if (lightboxCounter) lightboxCounter.textContent = `${currentIndex + 1} / ${thumbs.length}`;
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.classList.add('lightbox-open');
        lightbox.querySelector('[data-lightbox-close]')?.focus();
      } else if (lightbox?.classList.contains('is-open') && lightboxImage) {
        lightboxImage.src = thumb.dataset.gallerySrc;
        lightboxImage.alt = thumb.dataset.galleryAlt || '';
        if (lightboxCounter) lightboxCounter.textContent = `${currentIndex + 1} / ${thumbs.length}`;
      }
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
    gallery.querySelector('[data-gallery-previous]')?.addEventListener('click', () => showImage(currentIndex - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => showImage(currentIndex + 1));
    gallery.querySelector('[data-gallery-zoom]')?.addEventListener('click', () => showImage(currentIndex, true));
    lightbox?.querySelector('[data-lightbox-previous]')?.addEventListener('click', () => showImage(currentIndex - 1));
    lightbox?.querySelector('[data-lightbox-next]')?.addEventListener('click', () => showImage(currentIndex + 1));
    lightbox?.querySelector('[data-lightbox-close]')?.addEventListener('click', () => {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lightbox-open');
    });
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.querySelector('[data-lightbox-close]')?.click();
    });
    document.addEventListener('keydown', (event) => {
      if (!lightbox?.classList.contains('is-open')) return;
      if (event.key === 'Escape') lightbox.querySelector('[data-lightbox-close]')?.click();
      if (event.key === 'ArrowLeft') showImage(currentIndex - 1);
      if (event.key === 'ArrowRight') showImage(currentIndex + 1);
    });
    gallery.addEventListener('gallery:show-media', (event) => {
      const index = thumbs.findIndex((thumb) => thumb.dataset.mediaId === String(event.detail));
      if (index >= 0) showImage(index);
    });
  });

  document.querySelectorAll('[data-quantity-minus]').forEach((button) => button.addEventListener('click', () => {
    const input = button.closest('.quantity-selector')?.querySelector('[data-quantity-input]');
    if (input) input.value = Math.max(Number(input.min) || 1, Number(input.value) - 1);
  }));
  document.querySelectorAll('[data-quantity-plus]').forEach((button) => button.addEventListener('click', () => {
    const input = button.closest('.quantity-selector')?.querySelector('[data-quantity-input]');
    if (input) input.value = Math.max(1, Number(input.value) + 1);
  }));
});


document.addEventListener('DOMContentLoaded', () => {
  const estimatedArrival = new Date();
  estimatedArrival.setDate(estimatedArrival.getDate() + 15);
  const formattedArrival = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  }).format(estimatedArrival);
  document.querySelectorAll('[data-estimated-arrival]').forEach((element) => {
    element.textContent = formattedArrival;
  });
});
